const FirebaseConfig = {
  apiKey: "AIzaSyC33X_EWgzdizSXZ0z0gFru1F-xLwvR7Hw",
  authDomain: "aspect-e0f56.firebaseapp.com",
  databaseURL: "https://aspect-e0f56.firebaseio.com",
  projectId: "aspect-e0f56",
  storageBucket: "aspect-e0f56.appspot.com",
  messagingSenderId: "354031691594",
  appId: "1:354031691594:web:0698880a3bb959b7cf03b3",
  measurementId: "G-TLLTEW6R69",
};

export default FirebaseConfig

